import React from "react";
import Modal from "../../../../components/Common/Modal/Modal";
import EditDomainNameForm from "../EditDomainNameForm/EditDomainNameForm";

const EditDomainNameModal = ({
  editDomainNameId,
  editDomainName,
  handleSearchQuery,
  handleEditModal,
}) => {
  return (
    <Modal
      isOpen={editDomainNameId}
      heading={"Edit Domain Name"}
      toggle={() => handleEditModal(0)}
      width={"46.2"}
      height={"28.9"}
      justifyContent="normal"
    >
      <EditDomainNameForm
        editDomainNameId={editDomainNameId}
        handleSearchQuery={handleSearchQuery}
        editDomainName={editDomainName}
        handleEditModal={handleEditModal}
      />
    </Modal>
  );
};

export default EditDomainNameModal;
